// extracted by mini-css-extract-plugin
export default {"status_chart":"AppStatusChart_status_chart_ki9M4","status_chart_label":"AppStatusChart_status_chart_label_gTtf4","status_chart_wrapper":"AppStatusChart_status_chart_wrapper_RuFgQ"};